/**
 * @file IconTipRight Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-tip-right',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="4357"
  t="1681958127477"
  viewBox="0 0 1024 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z m268.8 320a50.176 50.176 0 0 0-70.4512 0L435.2 595.2512 313.5488 480.0512a50.176 50.176 0 0 0-70.3488 0 50.176 50.176 0 0 0 0 70.3488l153.6 153.6 6.4512 6.4512C409.6 716.8 422.4 716.8 435.2 716.8s25.6-6.4512 38.4-12.8l313.6512-313.6512c12.8-19.1488 12.8-51.2-6.4512-70.3488z"
    p-id="4358"
  />
</svg>
`
);
